import { IonIcon } from '@ionic/react'
import { Language } from '@vae/server/dist/client'
import { flash } from 'ionicons/icons'
import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import QRCode from 'react-qr-code'
import { AppContext } from '../../contexts/AppContext'
import useUser from '../../contexts/hooks/useUser'
import PageWrapper from '../../wrappers/pageWrapper/PageWrapper'

const DownloadApp: React.FC = () => {
	const { user } = useUser()

	const { isNativePlatform } = useContext(AppContext)
	const { t } = useTranslation('pages_downloadApp')

	const urls = useMemo(() => {
		const language = user?.language ?? Language.fi
		const appId = '1545659340'
		const packageName = 'com.vihreaalyenergia.app'

		return {
			apple: `https://apps.apple.com/fi/app/%C3%A4lyenergia/id${appId}${language === Language.fi ? '?l=fi' : ''}`,
			google: `https://play.google.com/store/apps/details?id=${packageName}${language === Language.fi ? '&hl=fi' : ''}`,
			appleNative: `itms-apps://apps.apple.com/app/id${appId}`,
			googleNative: `market://details?id=${packageName}`,
		}
	}, [user?.language])

	return (
		<PageWrapper page='downloadApp' appBarOptions={{ backPath: '/overview' }}>
			<div className='p-6 flex flex-col gap-8'>
				<span className='text-2xl text-center tracking-wide font-semibold text-text-dark dark:text-white'>
					{t('subtitle')}
				</span>

				<div className='flex flex-col gap-8 md:flex-row md:justify-around'>
					<div className='flex flex-col items-center gap-4'>
						<h3 className='text-lg font-medium text-text-dark dark:text-white m-0'>
							{t('iosTitle')}
						</h3>
						<div className='p-4 bg-white rounded-lg shadow-md flex justify-center items-center'>
							<QRCode value={urls.apple} size={180} />
						</div>{' '}
						<div className='mt-2'>
							<a
								href={isNativePlatform ? urls.appleNative : urls.apple}
								target='_blank'
								rel='noopener noreferrer'
							>
								<img
									src='/assets/app-store-badge.svg'
									alt='Download on the App Store'
									className='h-12 w-auto object-contain'
								/>
							</a>
						</div>
					</div>{' '}
					<div className='flex flex-col items-center gap-4'>
						<h3 className='text-lg font-medium text-text-dark dark:text-white m-0'>
							{t('androidTitle')}
						</h3>
						<div className='p-4 bg-white rounded-lg shadow-md flex justify-center items-center'>
							<QRCode value={urls.google} size={180} />
						</div>
						<div className='mt-2'>
							<a
								href={isNativePlatform ? urls.googleNative : urls.google}
								target='_blank'
								rel='noopener noreferrer'
							>
								<img
									src='/assets/google-play-badge.png'
									alt='Get it on Google Play'
									className='h-12 w-auto object-contain'
								/>
							</a>
						</div>
					</div>
				</div>

				<div className='bg-[#cae3cc] dark:bg-[#155f65] rounded-lg p-6'>
					<h3 className='text-lg font-medium text-text-dark dark:text-white mt-0 mb-4'>
						{t('benefitsTitle')}
					</h3>
					<ul className='pl-2 m-0'>
						<li className='mb-2 flex flex-row items-center text-text-dark dark:text-white last:mb-0'>
							<IonIcon icon={flash} className='mr-2 text-[#127d27] dark:text-[#3cb49f] text-xl' />
							{t('benefit1')}
						</li>
						<li className='mb-2 flex flex-row items-center text-text-dark dark:text-white last:mb-0'>
							<IonIcon icon={flash} className='mr-2 text-[#127d27] dark:text-[#3cb49f] text-xl' />
							{t('benefit2')}
						</li>
						<li className='mb-2 flex flex-row items-center text-text-dark dark:text-white last:mb-0'>
							<IonIcon icon={flash} className='mr-2 text-[#127d27] dark:text-[#3cb49f] text-xl' />
							{t('benefit3')}
						</li>
						<li className='mb-2 flex flex-row items-center text-text-dark dark:text-white last:mb-0'>
							<IonIcon icon={flash} className='mr-2 text-[#127d27] dark:text-[#3cb49f] text-xl' />
							{t('benefit4')}
						</li>
					</ul>
				</div>
			</div>
		</PageWrapper>
	)
}

export default DownloadApp
